import React, { useState } from 'react';
import { Camera, Image as ImageIcon, Info } from 'lucide-react';
import { t } from '../locales/nl';

interface PhotoModeToggleProps {
  isCameraMode: boolean;
  onToggle: () => void;
}

const PhotoModeToggle: React.FC<PhotoModeToggleProps> = ({
  isCameraMode,
  onToggle
}) => {
  const [showModeInfo, setShowModeInfo] = useState(false);

  return (
    <div className="fixed bottom-4 left-4 z-50 md:hidden">
      <div className="relative">
        <div className="flex items-center gap-2 bg-white rounded-full px-4 py-2 shadow-sm border border-neutral-200">
          <button
            type="button"
            onClick={onToggle}
            className="flex items-center gap-2"
            aria-label={isCameraMode ? 'Wissel naar gallerij modus' : 'Wissel naar camera modus'}
          >
            {isCameraMode ? (
              <ImageIcon size={20} className="text-blue-600" />
            ) : (
              <Camera size={20} className="text-blue-600" />
            )}
            <span className="text-sm font-medium text-neutral-700">
              {isCameraMode ? 'Camera' : 'Gallerij'}
            </span>
          </button>
          <button
            type="button"
            onClick={() => setShowModeInfo(!showModeInfo)}
            className="text-neutral-400 hover:text-neutral-600"
            aria-label="Show mode information"
          >
            <Info size={16} />
          </button>
        </div>
        
        {/* Mode Info Popup */}
        {showModeInfo && (
          <>
            <div 
              className="popup-overlay"
              onClick={() => setShowModeInfo(false)}
            />
            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm mx-4">
                <div className="space-y-4 text-neutral-600">
                  <div>
                    <h4 className="font-medium text-neutral-800 mb-1">{t.cameraMode}</h4>
                    <p className="text-sm">
                      {t.cameraModeDescription}
                    </p>
                  </div>
                  <div>
                    <h4 className="font-medium text-neutral-800 mb-1">{t.galleryMode}</h4>
                    <p className="text-sm">
                      {t.galleryModeDescription}
                    </p>
                  </div>
                </div>
                <button 
                  type="button"
                  onClick={() => setShowModeInfo(false)}
                  className="btn btn-primary w-full mt-4"
                >
                  {t.understood}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PhotoModeToggle; 